import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PageTile, SearchIcon, SvgIcon } from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';

import { PageLayout } from '../../layouts';

const NothingFoundWrapper = styled('div')(({ theme }) => ({
  height: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledPageTile = styled(PageTile)(({ theme }) => ({
  marginTop: 84,
}));

const StyledBodyText = styled(BodyText)(({ theme }) => ({
  marginTop: 8,
  color: theme.styleguideColors.contentSecondary,
}));

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.fillPrimaryRed,
  },
  marginBottom: 20,
}));

export interface NothingFoundSceneProps {
  message?: string;
}

export const NothingFound = ({ message }: { message?: string }) => {
  const { t } = useTranslation();
  return (
    <NothingFoundWrapper>
      <StyledSvgIcon src={SearchIcon} size={60} />
      <BodyText scale={'lg'} lineHeight={'sm'} size={1}>
        {t('Nothing was found')}
      </BodyText>
      <StyledBodyText size={3}>
        {message
          ? message
          : t('Try to search again using the search bar above')}
      </StyledBodyText>
    </NothingFoundWrapper>
  );
};

/**
 * NothingFoundScene is a functional component that renders a "Nothing Found" scene layout.
 * @NOTE Please, use it only when you working with Scenes aka pages, not inside other components,
 * because it will change `document.title` property as "Nothing Found"
 *
 * @param message - text that will be displayed under "Nothing was found"
 *
 */
export const NothingFoundScene = (props: NothingFoundSceneProps) => {
  return (
    <PageLayout title="Nothing Found">
      <StyledPageTile>
        <NothingFound {...props} />
      </StyledPageTile>
    </PageLayout>
  );
};
